class TextCardCarousel {
  constructor() {
    this.swiper = null;
    this.prevButton = null;
    this.nextButton = null;
    this.mobileQuery = window.matchMedia("(max-width: 1200px)");
    this.totalSlides = document.querySelectorAll(
      ".text-card-carousel__swiper-slide"
    ).length;

    this.swiperConfig = {
      slidesPerView: this.totalSlides <= 2 ? 1 : 1.5,
      spaceBetween: 5,
      watchOverflow: true,
      slidesPerGroupAuto: true,

      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },

      breakpoints: {
        768: {
          slidesPerView: this.totalSlides <= 2 ? 2 : 2.2,
          spaceBetween: 16,
        },
        980: {
          slidesPerView: this.totalSlides <= 2 ? 2 : 3.2,
        },
        1300: {
          slidesPerView: this.totalSlides <= 2 ? 2 : 3.5,
        },
      },

      navigation: {
        nextEl: "#next-button",
        prevEl: "#prev-button",
      },

      on: {
        init: this.handleInit.bind(this),
        slideChange: this.handleSlideChange.bind(this),
      },
    };

    this.init();
  }

  init() {
    this.swiper = document.querySelector(".text-card-carousel__swiper");
    if (!this.swiper) return;

    this.prevButton = document.querySelector("#prev-button");
    this.nextButton = document.querySelector("#next-button");

    this.initCarousel();
  }

  initCarousel() {
    this.swiper = new Swiper(this.swiper, this.swiperConfig);
  }

  logDebugInfo(type, data) {
    const styles = {
      state:
        "background: #2196F3; color: white; padding: 2px 5px; border-radius: 2px;",
      action:
        "background: #4CAF50; color: white; padding: 2px 5px; border-radius: 2px;",
      warning:
        "background: #FFC107; color: black; padding: 2px 5px; border-radius: 2px;",
    };

    console.groupCollapsed(`%c${type}`, styles[type.toLowerCase()]);
    Object.entries(data).forEach(([key, value]) => {
      console.log(`%c${key}:`, "font-weight: bold;", value);
    });
    console.groupEnd();
  }

  handleInit() {
    if (this.totalSlides <= 2) {
      const swiperWrapper = document.querySelector(
        ".text-card-carousel__swiper"
      );
      if (swiperWrapper) {
        swiperWrapper.style.margin = "0 auto";
      }
    }
  }

  handleSlideChange() {
    const totalSlides = this.swiper.slides.length;
    const currentIndex = this.swiper.activeIndex;
    const currentSlidesPerView = this.swiper.params.slidesPerView;
    const swiperWrapper = document.querySelector(
      ".text-card-carousel__swiper-wrapper"
    );

    // Log current state
    this.logDebugInfo("State", {
      "Total Slides": totalSlides,
      "Current Index": currentIndex,
      "Slides Per View": currentSlidesPerView,
      "Is Mobile": this.mobileQuery.matches,
      "Current Transform": swiperWrapper.style.transform,
      "Viewport Width": window.innerWidth,
    });

    if (
      this.totalSlides > 2 &&
      this.mobileQuery.matches &&
      currentIndex >= totalSlides - 2
    ) {
      this.logDebugInfo("Action", {
        Type: "Mobile Last Slide Translation",
        "Setting Transform": "translate3d(-1100px, 0px, 0px)",
        "Current Index": currentIndex,
        "Trigger Condition": `${currentIndex} >= ${totalSlides - 2}`,
      });

      if (this.mobileQuery.matches) {
        swiperWrapper.style.transform = "translate3d(-1140px, 0px, 0px)";
      }
    } else {
      this.handleLastSlideVisibility(
        totalSlides,
        currentIndex,
        currentSlidesPerView
      );
    }

    this.updateNavigationButtons();
  }

  handleLastSlideVisibility(totalSlides, currentIndex, currentSlidesPerView) {
    if (currentIndex >= totalSlides - currentSlidesPerView) {
      if (!this.mobileQuery.matches) {
        const lastSlideOffset =
          this.swiper.slidesGrid[totalSlides - 1] -
          this.swiper.slidesGrid[currentIndex];
        const translateX = this.swiper.getTranslate() - lastSlideOffset;

        this.logDebugInfo("Action", {
          Type: "Desktop/Tablet Translation",
          "Last Slide Offset": lastSlideOffset,
          "New TranslateX": translateX,
          "Current Index": currentIndex,
          "Slides Grid": this.swiper.slidesGrid,
        });

        this.swiper.setTranslate(translateX);
      }
    }
  }

  updateNavigationButtons() {
    if (this.swiper.isBeginning) {
      this.prevButton?.setAttribute("disabled", "");
    } else {
      this.prevButton?.removeAttribute("disabled");
    }

    if (this.swiper.isEnd) {
      this.nextButton?.setAttribute("disabled", "");
    } else {
      this.nextButton?.removeAttribute("disabled");
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new TextCardCarousel();
});
